import { FilePlus, FileText, Inbox, MessageSquare } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { PortalPjTab } from '@/components/layout/PortalPjLayout'

const PORTAL_TABS = [
  { id: 'nova' as const, label: 'Nova solicitação', icon: FilePlus },
  { id: 'meus' as const, label: 'Meus chamados', icon: Inbox },
  { id: 'nf' as const, label: 'Notas fiscais', icon: FileText },
  { id: 'feedback' as const, label: 'Feedback', icon: MessageSquare },
]

interface PortalPjTabsNavProps {
  activeTab: PortalPjTab
  onTabChange: (tab: PortalPjTab) => void
  className?: string
  showFeedback?: boolean
}

export function PortalPjTabsNav({ activeTab, onTabChange, className, showFeedback = true }: PortalPjTabsNavProps) {
  const tabs = showFeedback ? PORTAL_TABS : PORTAL_TABS.filter((tab) => tab.id !== 'feedback')

  return (
    <nav
      className={cn(
        'mb-6 flex gap-1 rounded-2xl border border-white/10 bg-white/[0.07] p-1 shadow-2xl shadow-black/20 backdrop-blur',
        className,
      )}
      role='tablist'
      aria-label='Navegação do portal'
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id
        const Icon = tab.icon
        return (
          <button
            key={tab.id}
            type='button'
            role='tab'
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex flex-1 items-center justify-center gap-2 rounded-md px-3 py-2.5 text-sm transition-colors',
              isActive
                ? 'bg-[#e91e63] font-semibold text-white shadow-lg shadow-[#e91e63]/25 ring-1 ring-white/15'
                : 'font-medium text-white/65 hover:bg-white/10 hover:text-white',
            )}
          >
            <Icon size={16} aria-hidden />
            <span className='truncate'>{tab.label}</span>
          </button>
        )
      })}
    </nav>
  )
}
